import { DeepReadonly } from 'utility-types';
import { IAssigneeGroup } from './assigneeGroup';
import { IAttachmentWithStatus } from './attachmentWithStatus';

export interface ITaskGroup {
  id: string;
  ownerType: OwnerType;
  ownerId: string;
  ownerName: string;
  assigneeGroups: IAssigneeGroup[];
  ignoredAssigneeGroups: IAssigneeGroup[];
  subject: string;
  content: string;
  canAssigneeComplete: boolean;
  attachments: DeepReadonly<IAttachmentWithStatus[]>;
  dueDateUtc: string;
  status: TaskStatus;
  isAttachmentRequiredForCompletion: boolean;
  createdDateUtc: string;
  createdByUserId: string;
  meta: ITaskGroupMeta;
}

interface ITaskGroupMeta {
  assigneeCount: number;
  awaitingActionCount: number;
  incompleteCount: number;
  completeCount: number;
}

export enum OwnerType {
  Organization = 'Organization'
}

export enum TaskStatus {
  AssigneeReplied = 'AssigneeReplied',
  AwaitingAction = 'AwaitingAction',
  AwaitingResponse = 'AwaitingResponse',
  Incomplete = 'Incomplete',
  Complete = 'Complete',
  OwnerReplied = 'OwnerReplied',
  Submitted = 'Submitted'
}
